// extracted by mini-css-extract-plugin
export default {"next_order":"IM","recurringdis":"JM","reactivate_button":"KM","order__summary_title":"LM","order__summary_items":"MM","order__summary_item":"NM","order__summary_item_title":"OM","order__summary_item_quantity":"PM","order__item_separator":"QM","discount":"RM","promowrapper":"SM"};
    if(module.hot) {
      // 1738836197154
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  